import {
  consulting,
  sourcing,
  managed,
  turnkey,
  staff,
} from "../controller/Images";

export const Serviceinfo = [
  {
    id: 6,
    icon: consulting,
    title: "CONSULTING",
    subtitle: "Clarity for complex decisions. Confidence in execution.",
    description:
      "We help CIOs and CXOs navigate digital transformation with practical, outcome-driven consulting that translates strategy into action.",
    subdescription: [
      "Clear technology and transformation roadmaps.",
      "Strong alignment between business strategy and IT.",
      "Optimized processes and improved operational efficiency.",
      "Governance, compliance, and risk management.",
      "Future-ready architectures that support growth.",
    ],
  },
  {
    id: 2,
    icon: managed,
    title: "MANAGED SERVICES",
    subtitle: "Run IT like a business stable, secure, and predictable.",
    description:
      "We take full ownership of your technology operations to ensure performance, resilience, and security freeing leadership teams to focus on growth and innovation.",
    subdescription: [
      "Predictable operations backed by SLAs.",
      "Reduced downtime, risk, and operational overhead.",
      "Secure, scalable cloud and application environments.",
      "Continuous optimization and performance monitoring.",
      "Strong governance and proactive support.",
    ],
  },
  {
    id: 3,
    icon: turnkey,
    title: "TURNKEY PROJECTS",
    subtitle:
      "From idea to go-live delivered with single-point accountability.",
    description:
      "We execute end-to-end technology initiatives that deliver faster time-to-value and reduced execution risk. One partner. One owner. Clear outcomes.",
    subdescription: [
      "Faster and predictable delivery of strategic initiatives.",
      "Seamless ERP, Cloud, AI, and enterprise system implementations.",
      "Integrated solutions aligned to existing ecosystems.",
      "Smooth change management and user adoption.",
      "Sustainable solutions with post-go-live support,.",
    ],
  },
  {
    id: 4,
    icon: staff,
    title: "DATA ANALYTICS & BUSINESS INTELLIGENCE",
    subtitle: "Turn data into decisions. Visibility into advantage.",
    description:
      "We enable CXOs to make faster, smarter decisions by transforming enterprise data into real-time insights that drive performance and accountability.",
    subdescription: [
      "Unified, trusted view of enterprise data.",
      "Executive dashboards and actionable reporting.",
      "Improved financial, operational, and strategic visibility.",
      "Real-time and self-service analytics for leadership teams.",
      "Analytics foundations ready for AI and advanced insights.",
    ],
  },
  {
    id: 1,
    icon: sourcing,
    title: "RIGHT SOURCING",
    subtitle:
      "Build the right delivery model. Control costs. Scale with confidence.",
    description:
      "We help CIOs design and execute sourcing strategies that balance cost efficiency, capability depth, and operational control without compromising quality or agility.",
    subdescription: [
      "Reduce IT delivery costs while improving productivity.",
      "Design optimal onshore, offshore, and hybrid sourcing models.",
      "Make confident build–buy–partner decisions.",
      "Improve vendor performance through governance and transparency.",
      "Scale teams and capabilities in line with business demand.",
    ],
  },
  {
    id: 5,
    icon: staff,
    title: "STAFF AUGMENTATION",
    subtitle: "Access the right talent exactly when you need it.",
    description:
      "We help organizations scale delivery capacity quickly by providing skilled professionals who integrate seamlessly with internal teams.",
    subdescription: [
      "Faster access to high-quality, ready-to-deploy talent.",
      "Flexible staffing models aligned to business priorities.",
      "Reduced hiring risk and recruitment overhead.",
      "Improved project velocity and delivery confidence.",
      "Onshore, offshore, and hybrid engagement options.",
    ],
  },
];


export const ERPinfo = [
  {
    id: 1,
    icon: "fa-solid fa-sitemap", // ERP Implementation
    title: "ERP IMPLEMENTATION",
    subtitle: "Seamless deployment for a future-ready business.",
    subdescription: [
      "End-to-end implementation with minimal downtime.",
      "Tailored setup for your unique workflows.",
      "Expert guidance from planning to go-live.",
    ],
  },
  {
    id: 2,
    icon: "fa-solid fa-sliders", // ERP Customization
    title: "ERP CUSTOMIZATION",
    subtitle: "Your processes, your ERP perfectly aligned. ",
    subdescription: [
      "Custom modules and dashboards to fit your needs.",
      "Scalable solutions for growing businesses.",
      "Industry-specific flexibility and enhancements.",
    ],
  },
  {
    id: 3,
    icon: "fa-solid fa-link", // ERP Integration
    title: "ERP INTEGRATION",
    subtitle: "Connect everything. Work smarter, not harder.",
    subdescription: [
      "Integration with existing apps and tools.",
      "Real-time data synchronization across departments.",
      "Eliminate silos for better collaboration.",
    ],
  },
  {
    id: 4,
    icon: "fa-solid fa-headset", // Support & Maintenance
    title: "SUPPORT & MAINTENANCE",
    subtitle: "Reliable support to keep your ERP running strong.",
    subdescription: [
      "24/7 technical assistance and troubleshooting.",
      "Regular updates and performance optimization.",
      "Proactive monitoring to prevent downtime.",
    ],
  },
  {
    id: 5,
    icon: "fa-solid fa-chalkboard-user", // Training & Consultation
    title: "TRAINING & CONSULTATION",
    subtitle: "Empower your team with expert guidance.",
    subdescription: [
      "Hands-on training for smooth adoption.",
      "Role-based learning for different departments.",
      "Ongoing consultation for continuous improvement.",
    ],
  },
   {
    id: 6,
    icon: "fa-solid fa-robot", // Training & Consultation
    title: "AI & AUTOMATION",
    subtitle: "Let intelligence drive efficiency.",
    subdescription: [
      "AI-powered workflow automation and scheduling.",
      "Smart alerts and predictive maintenance triggers.",
      "Reduce manual effort with intelligent process optimization.",
    ],
  },
];

export const IndustryInfo = [
  {
    id: 1,
    icon: "fa-solid fa-industry",
    title: "MANUFACTURING",
    paragraph: "Streamline production and inventory with precision.",
    list: [
      "Real-time tracking of raw materials and finished goods.",
      "Automated workflows for production planning.",
      "Reduce operational costs and improve efficiency.",
    ],
  },
  {
    id: 2,
    icon: "fa-solid fa-cart-shopping",
    title: "RETAIL & E-COMMERCE",
    paragraph: "Deliver seamless shopping experiences.",
    list: [
      "Centralized inventory and order management.",
      "Integrated POS and online sales channels.",
      "Data-driven insights for customer engagement.",
    ],
  },
  {
    id: 3,
    icon: "fa-solid fa-user-doctor",
    title: "HEALTHCARE",
    paragraph: "Simplify patient care and compliance.",
    list: [
      "Secure patient data management.",
      "Automated billing and insurance processes.",
      "Compliance with healthcare regulations.",
    ],
  },
  {
    id: 4,
    icon: "fa-solid fa-graduation-cap",
    title: "EDUCATION",
    paragraph: "Empower institutions with smart administration.",
    list: [
      "Student information and fee management.",
      "Timetable and resource scheduling.",
      "Enhanced academic performance reporting.",
    ],
  },
  {
    id: 5,
    icon: "fa-solid fa-file-invoice-dollar",
    title: "FINANCE & ACCOUNTING",
    paragraph: "Achieve accuracy and transparency in every transaction.",
    list: [
      "Automated financial reporting and compliance.",
      "Real-time cash flow and expense tracking.",
      "Integrated payroll and tax management.",
    ],
  },
  {
    id: 6,
    icon: "fa-solid fa-truck-fast",
    title: "LOGISTICS & SUPPLY CHAIN",
    paragraph: "Optimize movement from warehouse to doorstep.",
    list: [
      "Real-time shipment tracking.",
      "Inventory and demand forecasting.",
      "Reduce delays and improve delivery efficiency.",
    ],
  },
  {
    id: 7,
    icon: "fa-solid fa-person-digging",
    title: "CONSTRUCTION",
    paragraph: "Build smarter with integrated project management.",
    list: [
      "Track projects, budgets, and timelines in real time.",
      "Manage procurement and subcontractor workflows.",
      "Improve resource allocation and cost control.",
    ],
  },
  {
    id: 8,
    icon: "fa-solid fa-bell-concierge",
    title: "HOSPITALITY",
    paragraph: "Deliver exceptional guest experiences effortlessly.",
    list: [
      "Centralized booking and reservation management.",
      "Integrated POS for restaurants and services.",
      "Real-time inventory and staff scheduling.",
    ],
  },
  {
    id: 9,
    icon: "fa-solid fa-car-side",
    title: "AUTOMOTIVE",
    paragraph: "Drive efficiency across production and supply chain.",
    list: [
      "Manage parts inventory and vendor relationships.",
      "Track production and assembly line performance.",
      "Ensure compliance and quality standards.",
    ],
  },
  {
    id: 10,
    icon: "fa-solid fa-laptop-code",
    title: "IT SERVICES",
    paragraph: "Streamline operations for tech-driven businesses.",
    list: [
      "Project and resource management tools.",
      "Automated billing and SLA tracking.",
      "Real-time analytics for service delivery.",
    ],
  },
  {
    id: 11,
    icon: "fa-solid fa-capsules",
    title: "PHARMACEUTICALS",
    paragraph: "Ensure compliance and quality in every batch.",
    list: [
      "Batch tracking and regulatory compliance.",
      "Inventory control for raw materials and products.",
      "Integrated quality assurance workflows.",
    ],
  },
  {
    id: 12,
    icon: "fa-solid fa-building",
    title: "REAL ESTATE",
    paragraph: "Manage properties and clients with ease.",
    list: [
      "Automated lease and contract management.",
      "CRM for client interactions and follow-ups.",
      "Financial tracking for projects and rentals.",
    ],
  },
  {
    id: 13,
    icon: "fa-solid fa-burger",
    title: "FOOD & BEVERAGE",
    paragraph: "Maintain quality and efficiency from kitchen to customer.",
    list: [
      "Recipe and production planning.",
      "Inventory and wastage control.",
      "Integrated POS and delivery management.",
    ],
  },
  {
    id: 14,
    icon: "fa-solid fa-seedling",
    title: "FRESH PRODUCE",
    paragraph: "Keep your supply chain fresh and efficient.",
    list: [
      "Real-time tracking of perishable goods.",
      "Demand forecasting and inventory optimization.",
      "Compliance with food safety standards.",
    ],
  },
  {
    id: 15,
    icon: "fa-solid fa-warehouse",
    title: "WHOLESALE & DISTRIBUTION",
    paragraph: "Simplify bulk operations and logistics.",
    list: [
      "Centralized inventory and warehouse management.",
      "Automated order processing and invoicing.",
      "Real-time shipment tracking and route planning.",
    ],
  },
];
